// 最终优化版本
import React, { useMemo } from 'react';
import { AutoSizer, CellMeasurer, CellMeasurerCache, List } from 'react-virtualized';

const VirtualizedList = ({
  className,
  onScroll,
  overscanRowCount = 5, // 调优点：增加预渲染数量
  noRowsRenderer,
  gap = 0,
  Row = () => <div />,
  data = [],
}) => {
  const cache = useMemo(
    () =>
      new CellMeasurerCache({
        defaultHeight: 48,
        fixedWidth: true,
        // 性能调优参数
        minHeight: 24,
        keyMapper: (index) => data[index]?.id || index,
      }),
    [data]
  ); // 当data源变化时重置缓存

  const rowRenderer = ({ index, key, parent, style }) => {
    const itemData = data?.[index];

    return (
      <CellMeasurer cache={cache} columnIndex={0} key={key} parent={parent} rowIndex={index}>
        {({ measure, registerChild }) => (
          <div ref={registerChild} style={{ ...style, overflow: 'hidden', paddingBottom: gap }} onLoad={measure}>
            <Row index={index} data={itemData} />
          </div>
        )}
      </CellMeasurer>
    );
  };

  return (
    <div style={{ flex: 1 }}>
      <AutoSizer>
        {({ width, height }) => (
          <List
            deferredMeasurementCache={cache}
            keyMapper={(index) => data[index]?.id || index}
            className={className}
            height={height}
            width={width}
            overscanRowCount={overscanRowCount}
            noRowsRenderer={noRowsRenderer}
            rowCount={data.length}
            rowHeight={cache.rowHeight}
            rowRenderer={rowRenderer}
            onScroll={onScroll}
            // 启用强制重新计算模式
            recomputeRowHeightsAutomatically={true}
          />
        )}
      </AutoSizer>
    </div>
  );
};

export default React.memo(VirtualizedList); // 使用memo优化
